/**
 * Klientens spel-loop: fixed timestep (simTicksPerSecond från config) med
 * ackumulator; rendering varje rAF med interpolations-alpha. Simmen är
 * en ren funktion — loopen här är den enda som äger tid.
 */
import './style.css';
import { loadGameConfig } from './gameConfig';
import { Renderer } from './render/renderer';
import { createInitialState } from './sim/state';
import { step } from './sim/step';
import { InputHandler } from './ui/input';
import { Hud } from './ui/hud';

const LOCAL_PLAYER = 'p1';

async function main(): Promise<void> {
  const config = loadGameConfig();
  const host = document.getElementById('game');
  const hudHost = document.getElementById('hud');
  if (!host || !hudHost) throw new Error('Saknar #game/#hud i index.html');

  const renderer = new Renderer(config);
  await renderer.init(host);

  const input = new InputHandler(renderer, config, LOCAL_PLAYER);
  input.attach(renderer.canvas);
  const hud = new Hud(hudHost, input, LOCAL_PLAYER, config.match.simTicksPerSecond);

  // Seed: slumpad per match är OK — determinismen gäller givet seed.
  // (Math.random är förbjuden i sim; här är vi utanför sim.)
  const seed = (Math.random() * 0xffffffff) >>> 0;
  const state = createInitialState(seed, config);
  renderer.onTick(state);

  const tickMs = 1000 / config.match.simTicksPerSecond;
  const maxTicksPerFrame = 5; // undvik dödsspiral efter fliken varit i bakgrunden
  let accumulator = 0;
  let last = performance.now();

  function frame(now: number): void {
    accumulator = Math.min(accumulator + (now - last), tickMs * maxTicksPerFrame * 2);
    last = now;

    let ticks = 0;
    while (accumulator >= tickMs && ticks < maxTicksPerFrame) {
      step(state, input.drain(), config);
      renderer.onTick(state);
      accumulator -= tickMs;
      ticks++;
    }

    renderer.render(accumulator / tickMs);
    hud.update(state);
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}

void main();
